export default {
  plentiful_provider: 'Plentiful Pantry',
  other_pantry: 'Other Pantry',
  hot_meal: 'Hot Meal',
  non_food: 'Non Food',
};
